const queryKeys = {
  addEngagement: (queryparams) => ({
    key: `add-engagement`,
    url: `/insyts/engagement?isEmail=${queryparams}`,
  }),
  postEngagementDocument: {
    key: "post-engagement-document",
    url: "/insyts/engagement/document-upload",
  },
  postEngagementDocumentList: {
    key: "post-engagement-category-doc-list",
    url: "/insyts/engagement/category-doc",
  },
  getEngagementDocument: (engagementId) => ({
    key: `get-engagement-document-${engagementId}`,
    url: `/insyts/engagement/document-upload?engagementId=${engagementId}`,
  }),
  updateEngagement: {
    key: "update-engagement",
    url: "/insyts/engagement",
  },
  updateSubcontract: {
    key: "update-engagement",
    url: "/insyts/engagement/subcontractor",
  },
  getEngagements: (queryparams) => ({
    key: "get-engagements",
    url: `/insyts/engagement?${queryparams}`,
  }),
  getClientEngagements: {
    key: `get-client-engagements-list`,
    url: `/insyts/clients/engagement`,
  },
  getClientDetailed: (clientId) => ({
    key: `get-client-detailed-${clientId}`,
    url: `/insyts/clients/engagement?clientId=${clientId}&LastEvaluatedKey=0`,
  }),
  getEngagementById: (engagementId) => ({
    key: `get-engagement-${engagementId}`,
    url: `/insyts/engagement?engagementId=${engagementId}`,
  }),
  getEngagementCloneByEngagementId: (engagementId) => ({
    key: `get-engagement-clone-${engagementId}`,
    url: `/insyts/engagement/clone-engagement?engagementId=${engagementId}`,
  }),
  getAllClientsList: {
    key: `get-all-clients-list`,
    url: "/insyts-crm-clients/allClients",
  },
  getAllClientFiltered: {
    key: `get-all-clients-filtered`,
    url: "/insyts/engagementclientlist",
  },
  getClient: (clientId) => ({
    key: `get-client-${clientId}`,
    url: `/insyts-crm-clients/client-details?clientid=${clientId}&LastEvaluatedKey=0`,
  }),
  addClientSurvey: (engagementId) => ({
    key: "add-client-survey",
    url: "/insyts/engagement/client-survey?engagementId=" + engagementId,
  }),
  addClientSurveyEmail: (engagementId) => ({
    key: "add-client-survey",
    url: `/insyts/engagement/client-survey?isEmail=true&engagementId=${engagementId}`,
  }),
  postTimesheet: {
    key: "post-timesheet",
    url: "/insyts/timesheet",
  },
  updateTimesheet: {
    key: "update-timesheet",
    url: "/insyts/timesheet",
  },
  getTimesheet: {
    key: "get-timesheet",
    url: "/insyts/timesheet", // query Param: week, employeeId, status
  },
  getAdminApprovalTimesheet: (weeks) => ({
    key: `get-admin-approval-timesheet-${weeks}`,
    url: "/insyts/timesheet/pending",
  }),
  patchTodo: {
    key: "patch-todo",
    url: "/insyts/engagement/todo-task?updateType=single",
  },
  updateTodo: {
    key: "update-todo",
    url: "/insyts/engagement/todo-task?updateType=multi",
  },
  uploadTodoImage: {
    key: `upload-todo-image`,
    url: `/insyts/engagement/todo-files`,
  },
  getTodoImages: (todoId) => ({
    key: `get-todo-images-${todoId}`,
    url: `/insyts/engagement/todo-files?todoId=${todoId}`,
  }),
  getTodoList: (engagementId) => ({
    key: `get-engagement-todo-list-${engagementId ?? "nothing"}`,
    url: "insyts/engagement/todo",
  }),
  getTodoById: (engagementId, todoId) => ({
    key: `get-todo-${todoId}`,
    url: `insyts/engagement/todo?LastEvaluatedKey=0&engagementId=${engagementId}&todoId=${todoId}`,
  }),
  deleteTodo: (todoId, engagementId) => ({
    key: `delete-todo-${todoId}`,
    url: `insyts/engagement/todo?todoId=${todoId}&engagementId=${engagementId}`,
  }),
  postFilterTodoList: (engagementId) => {
    return {
      key: `post-filter-todo-list`,
      url:
        "insyts/engagement/todo-filter?engagementId=" +
        engagementId +
        "&LastEvaluatedKey=0",
    };
  },
  addTodoObj: {
    key: "add-todo",
    url: "insyts/engagement/todo",
  },
  getActivityLog: (queryparams) => ({
    key: `get-activity-log-${queryparams}`,
    url: `activitylog${queryparams}`,
  }),
  getResourcePlanDataById: (engagementId, queryparams) => ({
    key: `post-resource-${engagementId}`,
    url: `insyts/resource-plan/employee-list${queryparams}`,
  }),
  updateResource: {
    key: "patch-resource",
    url: "insyts/resource-plan",
  },
  getAllocatedResourceList: (weekList) => ({
    key: `post-resource-list-${weekList}`,
    url: `insyts/resource-plan/employee-list`,
  }),
  getResourePlanningList: (weekList) => ({
    key: `post-resource-planning-list-${weekList}`,
    url: `insyts/resource-plan`,
  }),
  getCapacityPlanningList: (weekList) => ({
    key: `post-capasity-planning-list-${weekList}`,
    url: `insyts/resource-plan`,
  }),
  getRoleDataList: (clientId) => ({
    key: `get-role-list`,
    url: `owner-roles/${clientId}`,
  }),
  getPeopleDataList: (clientId) => ({
    key: `get-people-list`,
    url: `add-users/${clientId}`,
  }),
  getLateCheckinReport: (clientId, uniqueId) => ({
    key: `get-latecheckin-report-${uniqueId}`,
    url: `late-checkin-report/${clientId}`,
  }),
  getAbsentReport: (clientId, uniqueId) => ({
    key: `get-absent-report-${uniqueId}`,
    url: `absent-report/${clientId}`,
  }),
  getEarlyCheckoutReport: (clientId, uniqueId) => ({
    key: `get-early-checkout-report-${uniqueId}`,
    url: `earlycheckout-report/${clientId}`,
  }),
  getAllBillList: (engagementId, queryparams) => ({
    key: `get-billlist-${engagementId}`,
    url: `/insyts/billing${queryparams}`,
  }),
  getClaims: (engagementId, clientId) => ({
    key: `get-claims-${clientId}`,
    url: `/insyts/timesheet/claims?engagementId=${engagementId}&clientId=${clientId}`,
  }),
  getHolidayList: (clientId) => ({
    key: `get-holiday-list-${clientId}`,
    url: `holiday-list/${clientId}`,
  }),
  getLeaveList: (clientId, payload) => ({
    key: `get-leave-list-${payload}`,
    url: `leave-list/${clientId}`,
  }),
  getEngagementDocumentList: (engagementId, queryparams) => ({
    key: `get-engagement-doc-list-${engagementId}`,
    url: `/insyts/engagement/category-doc${queryparams}`,
  }),
  getEngagementDocumentListId: (docId, queryparams) => ({
    key: `get-engagement-doc-list-${docId}`,
    url: `/insyts/engagement/category-doc/download?${queryparams}`,
  }),
  getBillingById: (engagementId) => ({
    key: `get-billlist-${engagementId}`,
    url: `/insyts/billing?engagementid=${engagementId}`,
  }),
  getTimeSheetByengagementId: (engagementId) => ({
    key: `get-timeSheet-by-engagementid-${engagementId}`,
    url: `/insyts/timesheet?engagementId=${engagementId}`,
  }),
  postClaimsAttachment: {
    key: `post-claims-timesheet-attachment`,
    url: `/insyts/timesheet/attachment`,
  },
  getAllEnggagements: {
    key: `get-all-engagements`,
    url: `/insyts/engagement`,
  },
  getClientsList: (office) => ({
    key: `get-clients-${office}`,
    url: `/insyts/clients`,
  }),
  getActualSummary: (engagementId, userId) => ({
    key: `get-claims-${engagementId}`,
    url: `/insyts/timesheet/actualsummary?engagementId=${engagementId}&userId=${userId}`,
  }),
  getActualSummaryToEngagementId: (engagementId) => ({
    key: `get-claims-to-${engagementId}`,
    url: `/insyts/timesheet/actualsummary?engagementId=${engagementId}`,
  }),
  postActualSummary: (body) => ({
    key: ["actualSummary", body.engagementId, body.userId],
    url: "insyts/timesheet/actualsummary",
    body,
  }),
  addEngagementAppraisal: {
    key: "add-engagement-appraisal",
    url: "/insyts/engagement/appraisal",
  },
  // New Api
  unapprovedTimesheets: {
    key: "unapproved-timesheets",
    url: "/insyts/timesheet/unapproved",
  },
  getBillingApprovals: (page, limit, statusname, userId, managingoffice, financeadmin) => {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);
    params.append("statusname", statusname);
    params.append("userId", userId);
    if (financeadmin === true) {
      params.append("financeadmin", "true");
      if (managingoffice) {
        params.append("managingoffice", managingoffice);
      }
    }
    return {
      key: `get-billing-approvals-${userId}-${financeadmin ? managingoffice : "non-fa"}`,
      url: `insyts/engagement/billing-approval?${params.toString()}`,
    };
  },
  getChargeoutRates: {
    key: "Chargeout",
    url: "settings/configuration",
  },
  getHistoryChargeoutRates: (queryparams) => ({
    key: `Chargeouthistory${queryparams}`,
    url: `settings/history?id=${queryparams}`,
  }),
  getPFAApproval: (queryparams) => ({
    key: `get-pfa-approval`,
    url: `/insyts/engagement/pfaapproval?${queryparams}`,
  }),
  updatePFAApproval: {
    key: `update-pfa-approval`,
    url: `/insyts/engagement/pfaapproval`,
  },
  getDeclaration: (userId, queryparams) => ({
    key: `declaration/${userId}`,
    url: `declaration/${userId}?${queryparams}`,
  }),
  getRolesList: (clientId) => ({
    key: `get-roles`,
    url: `owner-roles/${clientId}`,
  }),
  getPermissionByName: (clientId, roleId) => ({
    key: `get-roles-${clientId}-${roleId}`,
    url: `permissions/${clientId}/${roleId}`,
  }),
  getMyLeaveList: (clientId, payload) => ({
    key: `get-leave-list/${payload}`,
    url: `leave-list/${clientId}`,
  }),
  getPermissonNameList: (clientId) => ({
    key: `get-roles-${clientId}`,
    url: `permissions/nameList/${clientId}`,
  }),
  getAllDeclaration: (clientId, params) => ({
    key: `get-allDeclaration-${params}`,
    url: `/alldeclaration/${clientId}`,
  }),
  getAllTimesheetReport: (clientId, params) => ({
    key: `get-timesheet-report-${params}`,
    url: `/insytsreport/timesheet-data`,
  }),
  getOnboardingReport: (clientId, params) => ({
    key: `get-onboarding-report-${params}`,
    url: `/insytsreport/onboarding-data`,
  }),
  getEngagementCount: {
    key: `get-all-engagement-count`,
    url: "/insyts/loadengagement",
  },
  getEngagementFilterDropdown: (queryParams) => ({
    key: `get-engagement-filter-dropdown`,
    url: `/insyts/engagement/filterlist/${queryParams}`,
  }),
  getEngagementFilter: (queryParams) => ({
    key: `get-engagement-filter`,
    url: `/insyts/engagement/filter/${queryParams}`,
  }),
  getBillingFilterDropdown: (queryParams) => ({
    key: `get-billing-filter-dropdown`,
    url: `/insyts/engagement/approval-filterlist/${queryParams}`,
  }),
  getBillingFilter: (queryParams) => ({
    key: `get-billing-filter`,
    url: `/insyts/engagement/billingapproval-filter/${queryParams}`,
  }),
  getClientsList: (office) => ({
    key: `get-clients-${office}`,
    url: `/insyts-crm-clients`,
  }),
  getClientsName: (office) => ({
    key: `get-clients-${office}`,
    url: `/insyts-crm-clients/client-name`,
  }),
  getManagingOffice: () => ({
    key: "get-managing-office",
    url: `/insyts-crm-clients/managing-office`,
  }),

  getClientStatus: () => ({
    key: "get-client-status",
    url: `/insyts-crm-clients/client-status`,
  }),

  getClientOwner: () => ({
    key: "get-client-owner",
    url: `/insyts-crm-clients/client-owner`,
  }),

  getRelationshipManager: () => ({
    key: "get-relationship-manager",
    url: `/insyts-crm-clients/relationship-manager`,
  }),
  getClientIdCount: () => ({
    key: "get-client-id-count",
    url: `/insyts-crm-clients/count`,
  }),
  getClientDetailsById: (office) => ({
    key: `get-clients-${office}`,
    url: `/insyts-crm-clients/BDO`,
  }),
};

export default queryKeys;
